<template>
    <!-- end wrapper-->
    <footer class="footer footer-froDesk">
      <div class="footer-div">
        <div class="row mb-n3">
          <div class="col-sm-6 col-lg-4 mb-3">
            <ul class="footer-Friendship">
              <div class="clearfix">友情链接：</div>
              <li>
                <a href="http://www.nies.net.cn/" target="_blank">中国教科院</a>
              </li>
              <li>
                <a href="http://onsgep.moe.edu.cn/edoas2/website7/index.jsp" target="_blank">全国规划办</a>
              </li>
              <li>
                <a href="http://www.cnsaes.org.cn/" target="_blank">上海市教科院</a>
              </li>
              <li>
                <a href="http://www.cnsaes.org.cn/Organization/Index/19" target="_blank">上海市规划办</a>
              </li>
              <li>
                <a href="http://www.shyp.gov.cn/shypq/yqyw-wb-jyjzl/" target="_blank">黄埔区教育局</a
                >
              </li>
              <li>
                <a href="http://ypjxxy.edu.sh.cn/" target="_blank">黄埔区教育学院</a>
              </li>
              <!-- <li>
                <a href="http://ypdx.shyp.gov.cn/qwdx/jsfzzx/" target="_blank">黄埔区教师发展中心</a>
              </li>
              <li>
                <a href="http://www.ypjy.edu.sh.cn/YPEdu_Web/HTML/ypjyddy/ypjyddy_dyd/List/index.htm" target="_blank">黄埔教育科研区级课题</a>
              </li> -->
            </ul>
          </div>
          <div class="col-sm-6 col-lg-3 mb-3">
            <ul class="footer-host">
              <li>主办单位：黄埔区教育学院科研室</li>
              <li>联系地址：天宁区长江路340号</li>
              <li>联系电话：021-65035057</li>
            </ul>
          </div>
          <div class="col-sm-6 col-lg-3 mb-3">
            <!-- <ul class="footer-technology">
              <li>系统插件 ——<a href="">【点击下载】</a></li>
            </ul> -->
          </div>
          <div class="col-sm-6 col-lg-2 mb-3">
            <div class="footer-logo"></div>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
  data() {
    return {
      bottomList: [],
      contactList: [],
    };
  },
  mounted() {},
  methods: {
    //跳转外部链接
    toUrl(url) {
      if (!url) return;
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>

.footer {
	border-top: 1px solid rgba(152, 166, 173, .15);
	bottom: 0;
	color: #98a6ad;
	padding: 19px 30px 20px;
	// position: absolute;
	// right: 0;
	// left: 0
}
.footer .footer-links a {
	color: #98a6ad;
	margin-left: 1.5rem;
	-webkit-transition: all .4s;
	transition: all .4s
}

.footer .footer-links a:hover {
	color: #313a46
}

.footer .footer-links a:first-of-type {
	margin-left: 0
}

@media (max-width:767.98px) {
	.footer {
		left: 0 !important;
		text-align: center
	}
}

.footer-alt {
	left: 0;
	border: none;
	text-align: center
}

body[data-layout=topnav] .footer {
	left: 0 !important;
	padding: 19px 0 20px
}

body[data-layout=topnav].boxed-layout .footer {
	max-width: 1300px
}

body.boxed-layout .footer {
	border: none;
	margin: 0 auto;
	background-color: #fafbfe;
	-webkit-box-shadow: 0 0 35px 0 rgba(154, 161, 171, .15);
	box-shadow: 0 0 35px 0 rgba(154, 161, 171, .15);
	max-width: calc(1300px - 250px)
}
/* footer */
.container-froDesk {
  padding-bottom: 509px;
  min-height: calc(100vh - 509px);
}
.footer-froDesk {
  padding: 50px 0;
  background-color: #5172c5;
}
.footer-div {
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1200px;
}
.footer-froDesk ul {
  margin: 0;
  padding: 0;
  list-style: none;
  line-height: 2;
  text-align: left;
  color: #fff;
}
.footer-froDesk a {
  color: #fff;
}
.footer-Friendship > div {
  margin-top: -28px;
}
.footer-Friendship li {
  float: left;
  width: 50%;
}
.footer-logo {
  height: 84px;
  background: url("../../../assets/images/yf_images/logo_b_s.png") no-repeat center
    center;
}
@media (min-width: 576px) {
  .container-froDesk {
    padding-bottom: 323px;
    min-height: calc(100vh - 323px);
  }
  .footer-logo {
    background: url("../../../assets/images/yf_images/logo_b_s.png") no-repeat center
      center;
  }
}
@media (min-width: 992px) {
  .container-froDesk {
    padding-bottom: 185px;
    min-height: calc(100vh - 200px);
  }
  .footer-logo {
    background: url("../../../assets/images/yf_images/logo_b_s.png") no-repeat right
      center;
  }
}


</style>
